import { Btn, Breadcrumbs, H4 } from '../../../AbstractElements';
import React, { Fragment, useState, useCallback, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import { tableColumns } from '../../../Data/DataTable/Tag/tag';
// import axios from 'axios';
import EditTag from './EditTag';
import { Link } from 'react-router-dom';
import AddTag from './AddTag';
import { ServerPath } from '../../../Constant';
import Swal from 'sweetalert2';
import { Button } from 'react-bootstrap';
import { _axios } from '../../../utils/axios'; 


const DataTablesContain = () => {
  const [tags, setTags] = useState([]);


    const fetchdata = async () => {
      try {
        const response = await _axios.get(`${ServerPath}/tag/list`);
        const actualData = response?.data?.data;
        const tagData = actualData.map(tag => ({
          ...tag,
          tag_name: <div className="align-self-center"><div>{tag?.tag_name}</div></div>,
          status: <span
            className={`badge rounded-pill ${tag?.status === 1 ? 'badge-success' : 'badge-danger'}`}
            data-bs-toggle="modal"
            data-bs-target=".bd-example-modal-sm"
          >
            {tag?.status === 1 ? 'Active' : 'Inactive'}
          </span>,
          action: (
            <div className="action d-flex justify-content-center">
              <div className="edit" data-bs-toggle="modal" data-bs-target="#exampleModalCenter">
                {tag && <EditTag data={tag} />}
              </div>
              <div className="delete">
                <Button to="#" onClick={(e) => handleDeleteID(tag?.tag_id, e)} className="btn-square btn btn-danger mx-2"><i className="icon-trash"></i></Button>
              </div>
            </div>
          ),
        }));
        setTags(tagData);
      } catch (error) {
        console.error('Error fetching tags:', error);
      }
    };

    useEffect(() => {
      fetchdata();
    }, []);

  const handleDeleteID = async (tag_id, event) => {
    event.preventDefault();
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel!',
      customClass: {
        container: 'swal2-container'
      }
    });

    if (result.isConfirmed) {
      try {
        await _axios.delete(`${ServerPath}/tag/${tag_id}`);
        setTags(prevUsers => prevUsers.filter(user => user.user_id !== tag_id));
        Swal.fire(
          'Deleted!',
          'Your tag has been deleted.',
          'success'
        );
        fetchdata(); 
      } catch (error) {
        console.error('Error deleting tag:', error);
        Swal.fire(
          'Error!',
          'There was an error deleting the tag.',
          'error'
        );
      }
    }
  };

  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleDelet, setToggleDelet] = useState(false);

  const handleRowSelected = useCallback(state => {
    setSelectedRows(state.selectedRows);
  }, []);

  const handleDelete = () => {
    if (window.confirm(`Are you sure you want to delete:\r ${selectedRows.map(r => r.title)}?`)) {
      setToggleDelet(!toggleDelet);
      setTags(tags.filter((item) => selectedRows.filter((elem) => elem.id === item.id).length > 0 ? false : true));
      setSelectedRows('');
    }
  };

  return (
    <Fragment>
      <div className='row'>
        <div className='col-12 col-md-6 col-lg-6'>
          <Breadcrumbs mainTitle="Tags" parent="Tables" title="Tags" />
        </div>
        <div className='col-12 col-md-6 col-lg-6'>
          <AddTag />
        </div>
      </div>
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              {/* <HeadingCommon Heading={DataTableHeading}  /> */}
              <CardBody className='pt-0'>
                {(selectedRows.length !== 0) &&
                  <div className={`d-flex align-items-center justify-content-between bg-light-info p-2`}>
                    <H4 attrH4={{ className: 'text-muted m-0' }}>Delete Selected Data?</H4>
                    <Btn attrBtn={{ color: 'danger', onClick: () => handleDelete() }}>Delete</Btn>
                  </div>
                }
                <DataTable
                  className='data-tables theme-scrollbar pt-4'
                  data={tags}
                  columns={tableColumns}
                  striped={true}
                  center={true}
                  pagination
                  selectableRows
                  onSelectedRowsChange={handleRowSelected}
                  clearSelectedRows={toggleDelet}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>

  );

};
export default DataTablesContain;